import React from 'react'
import { Link } from 'react-router-dom'
import VipLayout from '../../../components/vip/VipLayout'

const ServicesIndexPage: React.FC = () => {
  return (
    <VipLayout>
      <main>
        <section className="hero">
          <div className="container">
            <span className="kicker">Services Center</span>
            <h1>服务中心</h1>
            <p>围绕企业设立与运营、互联网经营、AI 合规与内容服务资质，建立五大服务板块，帮助企业更清晰地理解所需资质、备案与申报路径。</p>
          </div>
        </section>
        <section className="section">
          <div className="container">
            <div className="grid cols-2">
              <div className="card service-card">
                <h3>企业工商财税咨询</h3>
                <p className="lead" style={{fontSize: '15px'}}>公司注册、变更、注销、财税咨询、企业基础合规咨询。</p>
                <Link className="btn btn-secondary" to="/vip/services/business-finance">进入页面</Link>
              </div>
              <div className="card service-card">
                <h3>知识产权咨询</h3>
                <p className="lead" style={{fontSize: '15px'}}>商标、专利、著作权咨询与布局建议。</p>
                <Link className="btn btn-secondary" to="/vip/services/intellectual-property">进入页面</Link>
              </div>
              <div className="card service-card">
                <h3>网站备案与互联网资质咨询</h3>
                <p className="lead" style={{fontSize: '15px'}}>ICP备案、ICP 经营许可证、EDI 许可证咨询。</p>
                <Link className="btn btn-secondary" to="/vip/services/internet-licenses">进入页面</Link>
              </div>
              <div className="card service-card">
                <h3>AI 资质与备案咨询</h3>
                <p className="lead" style={{fontSize: '15px'}}>AI 算法备案、AI 大模型登记 / 备案、私有化部署与训练微调咨询。</p>
                <Link className="btn btn-secondary" to="/vip/services/ai-compliance">进入页面</Link>
              </div>
              <div className="card service-card">
                <h3>社区 / 音视频 / AIGC 服务资质咨询</h3>
                <p className="lead" style={{fontSize: '15px'}}>网络文化经营许可证、广播电视节目制作经营许可证咨询服务。</p>
                <Link className="btn btn-secondary" to="/vip/services/content-licenses">进入页面</Link>
              </div>
            </div>
          </div>
        </section>
      </main>
    </VipLayout>
  )
}

export default ServicesIndexPage
